export const stepperTheme = {
    stepContainer: "flex justify-between justify-self-center w-full",
    stepItem: "relative flex flex-col justify-center items-center w-full",
    stepConnector: "before:content-[''] before:bg-neutral-500 before:absolute before:w-[70%] before:h-[1px] before:right-[65%] before:top-1/4 first:before:hidden",
    step: "w-8 h-8 flex items-center justify-center z-10 relative bg-neutral-10 rounded-lg font-semibold text-neutral-500",
    stepWording: "text-neutral-500 text-sm pt-3 font-bold"
};
